(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-fair-agenda"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sjelf-fair-agenda')){
customElements.define('sjelf-fair-agenda',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.rows=[...this.querySelectorAll('.sfa-event')];
this.period=this.querySelector('[data-period]');this.province=this.querySelector('[data-province]');this.month=this.querySelector('[data-month]');
const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
const part=t=>parts.find(p=>p.type===t).value;
this.today=part('year')+'-'+part('month')+'-'+part('day');
const d=new Date(this.today+'T12:00:00Z');const day=d.getUTCDay();const saturday=new Date(d);saturday.setUTCDate(d.getUTCDate()+(day===0?-1:6-day));const sunday=new Date(saturday);sunday.setUTCDate(saturday.getUTCDate()+1);
this.saturday=saturday.toISOString().slice(0,10);this.sunday=sunday.toISOString().slice(0,10);
const active=this.rows.filter(r=>r.dataset.end>=this.today);
const months=this.dataset.months.split(',');
[...new Set(active.map(r=>r.dataset.province))].sort((a,b)=>a.localeCompare(b,'nl')).forEach(v=>this.province.add(new Option(v,v)));
const keys=new Set();active.forEach(r=>{const d=new Date(r.dataset.start.slice(0,7)+'-01T12:00:00Z');const end=r.dataset.end.slice(0,7);while(d.toISOString().slice(0,7)<=end){const key=d.toISOString().slice(0,7);if(key>=this.today.slice(0,7))keys.add(key);d.setUTCMonth(d.getUTCMonth()+1);}});
[...keys].sort().forEach(v=>this.month.add(new Option(months[Number(v.slice(5))-1]+' '+v.slice(0,4),v)));
this.rows.sort((a,b)=>a.dataset.start.localeCompare(b.dataset.start)).forEach(r=>this.querySelector('.sfa-list').append(r));
[this.period,this.province,this.month].forEach(el=>el.addEventListener('change',()=>this.filter()));
this.querySelector('[data-reset]').addEventListener('click',()=>{this.period.value='all';this.province.value='';this.month.value='';this.filter();});
this.querySelector('.sfa-filters').hidden=false;this.filter();
}
filter(){
let count=0;this.rows.forEach(r=>{
const s=r.dataset.start,e=r.dataset.end;
const show=e>=this.today&&(!this.province.value||r.dataset.province===this.province.value)&&(!this.month.value||(s.slice(0,7)<=this.month.value&&e.slice(0,7)>=this.month.value))&&(this.period.value!=='weekend'||(s<=this.sunday&&e>=this.saturday));
r.hidden=!show;if(show)count++;
});
this.querySelector('[data-count]').textContent=count;this.querySelector('.sfa-empty').hidden=count!==0;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sjelf-footer')) {
    customElements.define('sjelf-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 750px)');
        this.sync = () => {
          this.querySelectorAll('details').forEach((details) => {
            details.open = this.media.matches;
            details.querySelector('summary').tabIndex = this.media.matches ? -1 : 0;
          });
        };
        this.guard = (event) => {
          if (this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.sync();
        this.media.addEventListener('change', this.sync);
        this.addEventListener('click', this.guard);
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.guard);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-genre-directory"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const wrap=root.querySelector('[data-genre-search-wrap]'),input=root.querySelector('[data-genre-search]'),items=[...root.querySelectorAll('[data-genre-item]')],empty=root.querySelector('[data-genre-empty]');const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');wrap.hidden=false;input.addEventListener('input',()=>{const q=norm(input.value);let count=0;items.forEach(li=>{li.hidden=!norm(li.textContent).includes(q);if(!li.hidden)count++;});empty.hidden=count>0;});}function all(){document.querySelectorAll('[data-genre-directory]').forEach(init);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();document.addEventListener('shopify:section:load',all);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-genre"] && !Shopify.designMode) return;
  try {
    
(()=>{const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function init(root){if(root.dataset.ready)return;root.dataset.ready='1';const data=Array.from(root.querySelectorAll('[data-sg-catalog]')).flatMap(node=>{try{const part=JSON.parse(node.textContent||'[]');return Array.isArray(part)?part:[];}catch(error){return [];}}),search=root.querySelector('[data-sg-search]'),filter=root.querySelector('[data-sg-filter]'),sort=root.querySelector('[data-sg-sort]'),grid=root.querySelector('[data-sg-results]'),status=root.querySelector('[data-sg-status]'),prev=root.querySelector('[data-sg-prev]'),next=root.querySelector('[data-sg-next]'),cache=new Map();let page=0,run=0;const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!=null)n.textContent=text;return n;};const money=cents=>new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR',maximumFractionDigits:cents%100?2:0}).format(cents/100);function card(p,row){const li=el('li','sg-card'),url='/products/'+encodeURIComponent(p.handle),cover=el('a','sg-cover');cover.href=url;if(p.featured_image){const img=el('img');img.src=p.featured_image+(p.featured_image.includes('?')?'&':'?')+'width=500';img.alt=p.title;img.loading='lazy';img.width=500;img.height=500;cover.append(img);}li.append(cover,el('p','sg-artist',row.artist));const h=el('h3'),a=el('a',null,row.album);a.href=url;h.append(a);li.append(h,el('p','sg-price',money(p.price)));const variant=p.variants.find(v=>v.available)||p.variants[0],pre=p.available&&p.tags.includes('SJELF: PRE-ORDER');li.append(el('p','sg-status',!p.available?'Momenteel uitverkocht':pre?(row.release?'PRE-ORDER Vanaf '+row.release.split('-').reverse().join('-'):'PRE-ORDER'):'Beschikbaar'));const form=el('form');form.method='post';form.action=(window.Shopify?.routes?.root||'/')+'cart/add';const id=el('input');id.type='hidden';id.name='id';id.value=variant.id;const btn=el('button','sg-button',p.available?'ADD TO CART.':'SOLD OUT.');btn.type='submit';btn.name='add';btn.disabled=!p.available;form.append(id,btn);li.append(form);return li;}
async function draw(){const token=++run;let rows=data.filter(r=>norm(r.artist+' '+r.album).includes(norm(search.value))&&(filter.value==='all'||r.state===filter.value));rows.sort((a,b)=>({available:0,preorder:1,soldout:2}[a.state]??3)-({available:0,preorder:1,soldout:2}[b.state]??3)||norm(a[sort.value]).localeCompare(norm(b[sort.value]),'nl'));const pages=Math.max(1,Math.ceil(rows.length/12));page=Math.min(page,pages-1);root.querySelector('[data-sg-count]').textContent=rows.length+' UITGAVEN';root.querySelector('[data-sg-page]').textContent=(page+1)+' / '+pages;prev.disabled=page===0;next.disabled=page===pages-1;status.textContent=rows.length?'Platen laden…':'Geen platen gevonden. Probeer een andere zoekterm.';grid.replaceChildren();root.querySelector('[data-sg-pagination]').hidden=pages<=1;const selected=rows.slice(page*12,page*12+12);const cards=await Promise.all(selected.map(async row=>{try{if(!cache.has(row.handle))cache.set(row.handle,fetch('/products/'+encodeURIComponent(row.handle)+'.js').then(r=>{if(!r.ok)throw Error();return r.json();}));return card(await cache.get(row.handle),row);}catch(e){const li=el('li','sg-card'),a=el('a','sg-text-link',row.artist+' — '+row.album);a.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(row.handle);li.append(a,el('p','sg-status','Bekijk prijs en beschikbaarheid op de productpagina.'));return li;}}));if(token!==run)return;grid.replaceChildren(...cards);status.textContent='';}
root.addEventListener('submit',async event=>{const form=event.target;if(!(form instanceof HTMLFormElement)||!form.action.includes('/cart/add'))return;event.preventDefault();event.stopPropagation();const button=form.querySelector('button[type="submit"]');if(button.disabled)return;const before=button.textContent;button.disabled=true;button.textContent='TOEVOEGEN…';let note=form.querySelector('[role="status"]');if(!note){note=el('p','sg-status');note.setAttribute('role','status');form.append(note);}try{const body=new FormData(form);if(!body.get('id'))throw Error('Open de plaat om jouw uitvoering te kiezen.');const response=await fetch('/cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw Error(result.description||'Toevoegen lukt momenteel niet. Probeer opnieuw.');window.location.assign('/cart');}catch(error){note.textContent=error.message;button.disabled=false;button.textContent=before;}},true);root.querySelector('[data-sg-controls]').hidden=false;let timer;search.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>{page=0;draw();},220);});filter.addEventListener('change',()=>{page=0;draw();});sort.addEventListener('change',()=>{page=0;draw();});prev.addEventListener('click',()=>{page--;draw();});next.addEventListener('click',()=>{page++;draw();});const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();draw();}},{rootMargin:'300px'});observer.observe(root.querySelector('#genre-vinyl'));}function all(){document.querySelectorAll('[data-sg]').forEach(init);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();document.addEventListener('shopify:section:load',all);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-home-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sjelf-lp-carousel')) {
  customElements.define('sjelf-lp-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.viewport = this.querySelector('.sjv-viewport');
      this.slides = [...this.querySelectorAll('[data-sjv-slide]')];
      this.dots = [...this.querySelectorAll('[data-sjv-dot]')];
      this.toggle = this.querySelector('[data-sjv-toggle]');
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.hovered = false;
      if (this.slides.length < 2) return;
      this.querySelector('.sjv-controls').hidden = false;
      const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, { ...options, signal });
      on(this.querySelector('[data-sjv-prev]'), 'click', () => this.go(this.index - 1, true));
      on(this.querySelector('[data-sjv-next]'), 'click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.go(index, true)));
      on(this.toggle, 'click', () => { this.paused = !this.paused; this.update(); this.schedule(); });
      on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => this.schedule());
      on(this, 'focusout', () => queueMicrotask(() => this.schedule()));
      on(this.viewport, 'pointerdown', () => this.stop());
      on(this.viewport, 'keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(this.viewport, 'scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const left = this.viewport.getBoundingClientRect().left;
          this.index = this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
          this.update();
          this.schedule();
        }, 130);
      }, { passive: true });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.reduced, 'change', () => { if (this.reduced.matches) this.stop(); });
      on(this, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target) || slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.go(index, true, 'instant');
      });
      this.resize = new ResizeObserver(() => {
        const slide = this.slides[this.index];
        this.viewport.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'instant' });
      });
      this.resize.observe(this.viewport);
      this.update();
      this.schedule();
    }
    stop() {
      this.paused = true;
      this.update();
      this.schedule();
    }
    go(index, manual = false, behavior) {
      if (manual) this.stop();
      this.index = (index + this.slides.length) % this.slides.length;
      this.viewport.scrollTo({ left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior: behavior || (this.reduced.matches ? 'instant' : 'smooth') });
      this.update();
      this.schedule();
    }
    update() {
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      this.slides.forEach((slide, index) => {
        slide.querySelectorAll('a').forEach(link => link.tabIndex = index === this.index ? 0 : -1);
      });
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
      this.toggle.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      this.querySelector('[data-sjv-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) * 1000 || 7000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      clearTimeout(this.timer);
      clearTimeout(this.scrollTimer);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-home-hero"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('sjelf-home-hero')){
 class SjelfHomeHero extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   this.viewport=this.querySelector('[data-hero-viewport]');
   this.slides=[...this.querySelectorAll('[data-hero-slide]')];
   this.dots=[...this.querySelectorAll('[data-hero-dot]')];
   this.previous=this.querySelector('[data-hero-previous]');
   this.next=this.querySelector('[data-hero-next]');
   this.counter=this.querySelector('[data-hero-count]');
   if(!this.viewport||!this.slides.length)return;
   const signal=this.abort.signal;
   this.index=0;
   this.previous?.addEventListener('click',()=>this.go(this.index-1),{signal});
   this.next?.addEventListener('click',()=>this.go(this.index+1),{signal});
   this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i),{signal}));
   this.viewport.addEventListener('scroll',()=>{
    cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update(Math.round(this.viewport.scrollLeft/this.viewport.clientWidth)));
   },{passive:true,signal});
   this.viewport.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
     event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1));
    }
   },{signal});
   document.addEventListener('shopify:block:select',event=>{
    const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);
    if(index>=0)this.go(index,true);
   },{signal});
   this.resize=new ResizeObserver(()=>this.go(this.index,true));
   this.resize.observe(this.viewport);this.update(0);
  }
  update(index){
   this.index=Math.max(0,Math.min(this.slides.length-1,index));
   this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
   this.slides.forEach((slide,i)=>slide.inert=i!==this.index);
   if(this.previous)this.previous.disabled=this.index===0;
   if(this.next)this.next.disabled=this.index===this.slides.length-1;
   if(this.counter)this.counter.textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
  }
  go(index,instant=false){
   index=Math.max(0,Math.min(this.slides.length-1,index));
   this.viewport.scrollTo({left:index*this.viewport.clientWidth,behavior:instant||matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   if(instant)this.update(index);
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
 }
 customElements.define('sjelf-home-hero',SjelfHomeHero);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjelf-sunday-spin-signup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'sjelf-sunday-spin-popup';

    document.querySelectorAll('[data-sjelf-spin-signup]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const popup = section.querySelector('[data-spin-popup]');
      if (!popup || section.dataset.popupEnabled !== 'true') return;
      if (section.querySelector('[data-spin-success]')) return;

      const repeatDays = Number(section.dataset.popupRepeat || 14);
      const delay = Number(section.dataset.popupDelay || 15) * 1000;
      const scrollTarget = Number(section.dataset.popupScroll || 35) / 100;
      let lastShown = 0;

      try {
        lastShown = Number(window.localStorage.getItem(storageKey) || 0);
      } catch (error) {
        lastShown = 0;
      }

      if (lastShown && Date.now() - lastShown < repeatDays * 86400000) return;

      let timeReady = false;
      let scrollReady = scrollTarget === 0;
      let opened = false;

      const remember = () => {
        try {
          window.localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {
          return;
        }
      };

      const maybeOpen = () => {
        if (opened || !timeReady || !scrollReady) return;
        opened = true;
        if (typeof popup.show === 'function') popup.show();
        else popup.setAttribute('open', '');
        remember();
      };

      const checkScroll = () => {
        const available = document.documentElement.scrollHeight - window.innerHeight;
        scrollReady = available <= 0 || window.scrollY / available >= scrollTarget;
        maybeOpen();
      };

      window.setTimeout(() => {
        timeReady = true;
        checkScroll();
      }, delay);

      window.addEventListener('scroll', checkScroll, { passive: true });

      popup.querySelector('[data-spin-popup-close]')?.addEventListener('click', () => {
        if (typeof popup.close === 'function') popup.close();
        else popup.removeAttribute('open');
        remember();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
